import checkForm from "./schemas/checkIn/form";
import checkValidations from "./schemas/checkIn/validations";
import paymentForm from "./schemas/payment/form";
import paymentValidations from "./schemas/payment/validations";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {API_URL} from "../../../config";
import {useSnackbar} from "../../../context/SnackbarContext/SnackbarContext";
import {capitalizeFirstLetter} from "../../../helpers/helpers";
import Chip from "@mui/material/Chip";
import {useSelector} from "react-redux";
import moment from "moment/moment";

const useCheckIn = () => {

    const sessionState = useSelector((state) => state.sessionReducer);

    const { showSnackbar } = useSnackbar();

    const [isLoading, setIsLoading] = useState(true);

    const [members, setMembers] = useState([]);
    const [selectedMember, setSelectedMember] = useState(null);

    const [filters, setFilters] = useState(null);
    const [shouldRefresh, setShouldRefresh] = useState(false);

    const actions = {
        add: false,
        edit: false,
        delete: false,
    };

    useEffect(() => {

        const init = async () => {
            setIsLoading(true);
            await loadMembers();
            setIsLoading(false);
        };

        init();

    }, []);

    const loadMembers = async () => {

        try {

            const response = await axios.get(`${API_URL}/members`, {
                params: {
                    sort: 'name',
                    direction: 'asc',
                    active: true
                }
            });

            if(response.data.length > 0)
                setMembers([{id: -1, label: "Choose a member"}, ...response.data.map(member => ({id: member.id, label: `${capitalizeFirstLetter(member.name)}`}))]);

        } catch (error) {

            showSnackbar('Check In', 'Something went wrong loading the members', 'cancel', 'warning');

        }

    };

    const handleCheckIn = async () => {

        try {

            // Enviar datos a API
            await axios.post(
                `${API_URL}/session/members/check-in`,
                {member_id: selectedMember.id}
            );

            showSnackbar('Check In', 'Member successfully checked in', 'notifications', 'success');
            setSelectedMember(null);

        } catch (error) {

            showSnackbar('Check In', error.response.data.message, 'cancel', 'warning');

        }

    };

    const handleCheckMembership = async (values, actions) => {

        try {

            // Enviar datos a API
            const response = await axios.get(
                `${API_URL}/members/${values.member_id}`
            );

            setSelectedMember(response.data);
            actions.resetForm();

        } catch (error) {

            showSnackbar('Check In', error.response.data.message, 'cancel', 'warning');

        }

        actions.setSubmitting(false);

    };

    const handlePayment = async (values, actions) => {

        try {

            let data = {...values};

            if (data.end_at) {
                data.end_at = moment(data.end_at).format('YYYY-MM-DD');
            }

            data.member_id = selectedMember.id;

            // Enviar datos a API
            await axios.post(
                `${API_URL}/payments`,
                data
            );

            await handleCheckIn();

            actions.resetForm();

        } catch (error) {

            showSnackbar('Membership', error.response.data.message, 'cancel', 'warning');

        }

        actions.setSubmitting(false);

    };

    const renderStatusChip = (status) => {
        switch (status) {
            case 'waiting':
                return <Chip size="small" color="secondary" label="Waiting"
                             variant="outlined"/>;
            case 'playing':
                return <Chip size="small" color="warning" label="Playing"
                             variant="outlined"/>;
            case 'done':
                return <Chip size="small" color="success" label="Done"
                             variant="outlined"/>;
        }
    };

    return {
        selectedMember,
        checkValidations,
        checkForm,
        paymentForm,
        paymentValidations,
        isLoading,
        members,
        handleCheckIn,
        handleCheckMembership,
        handlePayment,
        actions,
        filters,
        setFilters,
        renderStatusChip,
        shouldRefresh,
        setShouldRefresh,
        sessionState
    };
};

export default useCheckIn;
